export default __webpack_public_path__ + "static/media/icon-solution-1.f48ad87f.svg";